export default "__VITE_ASSET__mqhJfcyZ__"